<ng-container>
  <div class="paginator-container mb-60" [ngClass]="getClassPosition()">
    <div class="paginator-wrapper" *ngIf="!_viewAllMode && pageCount > 1">
      <div class="pager__range" aria-live="polite">{{ rangeLabel }}</div>
      <button ds365Button status="secondary" size="sm" class="me-2 mb-2"
        [disabled]="disabled || loading || _currentPage === 1" (click)="first()" aria-label="First page">«</button>

      <button ds365Button status="secondary" size="sm" class="me-2 mb-2"
        [disabled]="disabled || loading || _currentPage === 1" (click)="prev()" aria-label="Previous page">‹</button>

      <span class="paginator-link" role="group" aria-label="Page list">
        <ng-container *ngFor="let item of pageWindow">
          <ng-container *ngIf="item !== '…'; else dots">
            <button ds365Button size="sm" class="ms-1 me-1 paginator-link__num"
              [ngClass]="item === _currentPage ? 'paginator-link__num--active' : ''"
              [attr.aria-current]="item === _currentPage ? 'page' : null" [disabled]="disabled || loading"
              (click)="goToPage($any(item))">
              {{ item }}
            </button>
          </ng-container>
          <ng-template #dots>
            <span class="ms-2 me-2 paginator-link__dots" aria-hidden="true">…</span>
          </ng-template>
        </ng-container>
      </span>

      <button ds365Button status="secondary" size="sm" class="ms-2 me-2 mb-2"
        [disabled]="disabled || loading || _currentPage === pageCount" (click)="next()"
        aria-label="Next page">›</button>

      <button ds365Button status="secondary" size="sm" class="me-2 mb-2"
        [disabled]="disabled || loading || _currentPage === pageCount" (click)="last()"
        aria-label="Last page">»</button>

      <span [ngbTooltip]="count >= viewAllSoftLimit ? 'Disabled for large datasets (> ' + viewAllSoftLimit + ')' : null"
        container="body" class="d-inline-block">
        <button *ngIf="count > 0" ds365Button status="primary" size="sm" class="ms-2 mb-2"
          [disabled]="disabled || loading || count >= viewAllSoftLimit" (click)="viewAll()"
          [attr.aria-disabled]="(disabled || loading || count >= viewAllSoftLimit) ? true : null">
          View All
        </button>
      </span>

    </div>

    <div *ngIf="_viewAllMode" class="paginator-wrapper">
      <div class="pager__range" aria-live="polite">Showing all {{ count }} rows</div>
      <button ds365Button status="primary" size="sm" class="ms-2 mb-2" (click)="reset()">
        View Paged
      </button>
    </div>

  </div>
</ng-container>